import {
    FC,
    ReactElement,
    useEffect,
    useState,
} from 'react'

import { UserWithConceptAvailability } from '../../../../../../models'
import ConceptAvailability from '../../../ConceptAvailability/ConceptAvailability'
import { ResourceTypes } from '../../ConceptsListViewTable'
import { getOverlappingResourcesOnDate } from './helpers/transformResources'

interface UserConceptAvailabilityOnDateProps {
    isLoading: boolean;
    user: UserWithConceptAvailability;
    day: Date;
    onAvailabilityClick: (resources: ResourceTypes) => void;
}

const UserConceptAvailabilityOnDate: FC<UserConceptAvailabilityOnDateProps> = ({
    isLoading,
    user,
    day,
    onAvailabilityClick,
}): ReactElement => {
    const [resourcesState, setResourcesState] = useState<ResourceTypes[]>([])

    useEffect(() => {
        if (! isLoading) {
            setResourcesState(getOverlappingResourcesOnDate(
                user.leaveOfAbsences,
                user.absences,
                user.preferToWorkTimeSlots,
                user.unavailableToWorkTimeSlots,
                day,
                user.shiftConceptPlannings,
                user.shiftPlannings,
            ))
        }
    }, [user, day, isLoading])

    return (
        <>
            {
                resourcesState.map(resource => (
                    <ConceptAvailability
                        showDescription
                        key={resource.id}
                        resource={resource}
                        onClick={onAvailabilityClick}
                    />
                ))
            }
        </>
    )
}

export default UserConceptAvailabilityOnDate
